
const POPUP_TIMEOUT_MS = 100;

export { POPUP_TIMEOUT_MS }
